/**
 * Teacher dashboard feature flags — single source of truth.
 *
 * The values ARE the exact backend configuration keys queried via
 * `configurationsService.getConfiguration`. The expressive keys (`RADAR`,
 * `ANALYTICS_PANEL`, `AI_TOOLS`) are what we reference in code; the string
 * values are the server contract and must NOT be renamed without a matching
 * backend change.
 *
 * The same value is used on every side, so they can never drift:
 * - the `feature` tag on a route config (`routesConfig.js`)
 * - the keys of the object returned by `useTeacherDashboardFeatures`
 * - `filterRoutesByFeatures`, which matches a route's `feature` against those keys
 */
export const TEACHER_DASHBOARD_FEATURES = {
  RADAR: 'feature.teacher_radar',
  ANALYTICS_PANEL: 'feature.teacher_analytics_panel',
  AI_TOOLS: 'feature.teacher_ai_tools',
} as const;

export type TeacherDashboardFeature = (typeof TEACHER_DASHBOARD_FEATURES)[keyof typeof TEACHER_DASHBOARD_FEATURES];
